import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import { Checkboxes } from "../../../FlowConfigurationInputs";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

export default function Create({
  action,
  variables,
  setOpenVariable,
  automId
}) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.FILE.";
  // checkbox options 
  const options = {
    checkboxes: { label: label + "OVERWRITE" },
  };

  return (
    <div>
      <div className="conf-field-container">
        <FieldLabel name={t(label + "FOLDER-PATH")} is_required />
        <TextInput
          action={action}
          inputName="folderPath"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired
          extractPath="folder"
          fieldType="string"
          displayName={t(label + 'FOLDER-PATH')}
          hideRequired
          autom_id={automId}
        />
      </div>
      <div className="conf-field-container">
        <FieldLabel name={t(label + "FILE-NAME-AND-EXT")} is_required />
        <TextInput
          action={action}
          inputName="fileName"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired
          fieldType="string"
          displayName={t(label + 'FILE-NAME-AND-EXT')}
          hideRequired
          autom_id={automId}
        />
        <small className="conf-field-desc"><em>Ex: example.txt</em></small>
      </div>
      <div className="conf-field-container">
        <Checkboxes
          action={action}
          inputName="overwriteFile"
          options={options.checkboxes}
        />
      </div>
    </div>
  );
}
